import type { SVGProps } from "react";
import { Icon, type IconProps } from "../Icon";
const InternalSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.2}
      d="M12 6.5c-.667 0-2.2.2-3 1s-3 2.333-4 3c-.667.333-2.1 1.3-2.5 2.5-.5 1.5-.5 3 2 3M8.5 16h7"
    />
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      d="M8.4 15.5a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0Z"
    />
    <path
      d="m21.5 15-.537-.268zm-4-8-.223.557.017.007.016.005zm3.464.38a.6.6 0 1 0-.928-.76L20.5 7zM19.5 15.5l-.268.537c.166.083.38.135.584.162.215.03.467.039.726.01.496-.056 1.162-.276 1.495-.94L21.5 15l-.537-.268c-.067.135-.235.248-.555.284a1.8 1.8 0 0 1-.588-.036q-.063-.02-.052-.017zm2-.5.537.268c.639-1.278.575-2.736.127-4.06a8.4 8.4 0 0 0-2.329-3.491l-.398.448-.399.449a7.2 7.2 0 0 1 1.989 2.978c.38 1.12.391 2.23-.064 3.14zm-2.063-6.835.398-.448c-.645-.573-1.377-1.03-2.145-1.286L17.5 7l-.19.57c.585.194 1.178.555 1.728 1.044zM17.5 7l.223-.557c-1.187-.475-2.192-.382-2.826.247-.602.598-.674 1.501-.402 2.212.283.741.97 1.372 1.983 1.406.975.032 2.116-.495 3.375-1.71l-.416-.433-.417-.431c-1.153 1.113-1.994 1.391-2.503 1.374a.955.955 0 0 1-.901-.634c-.144-.377-.063-.745.127-.933.158-.157.582-.365 1.534.016zm1.937 1.165.416.432q.536-.515 1.111-1.217L20.5 7l-.464-.38c-.358.438-.697.806-1.016 1.114z"
      style={{
        fill: "var(--icon-accent,#E47B53)",
      }}
    />
    <path
      stroke="currentColor"
      strokeWidth={1.2}
      d="M19.4 15.5a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0Z"
    />
  </svg>
);
export const CarIcon = (props: IconProps) => (
  <Icon {...props} Icon={InternalSvg} />
);
